import { TikTokUrlUtilsException } from "./TikTokUrlUtilsException";

export class TikTokUrlUtils {
    static getTikTokPostIdFromLink(link: string): string {
        const lastSlash = link.lastIndexOf("/");
        const lastQuestion = link.lastIndexOf("?");
        const id = link.slice(
            lastSlash + 1,
            lastQuestion !== -1 ? lastQuestion : undefined
        );
        if (!id || isNaN(parseInt(id))) {
            throw new TikTokUrlUtilsException(
                "Incorrect url to post (without id)"
            );
        }
        return id;
    }

    static getEmbedIframeUrl(postUrl: string): string {
        const id = TikTokUrlUtils.getTikTokPostIdFromLink(postUrl);
        return `https://www.tiktok.com/embed/v2/${id}?lang=en-US`;
    }
}
